import { useState, useEffect, useRef } from 'react';

const baseUrl = process.env.PUBLIC_URL || '';
const categories = [
  { id: 1, name: 'Jute Bags', image: `${baseUrl}/totebag.png` },
  { id: 2, name: 'Cotton Canvas Bags', image: `${baseUrl}/bag2.png` },
  { id: 3, name: 'Pouches', image: `${baseUrl}/bag3.png` },
  { id: 4, name: 'Wine Bags', image: `${baseUrl}/bag4.png` },
];

export const CategoryGrid = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="collections"
      ref={sectionRef}
      className="py-14 md:py-20 bg-[#F8F6F2] border-t border-gray-200 px-5 md:px-0"
      data-testid="category-section"
    >
      <div className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8">
        {/* Category Grid - Titles ABOVE images */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((category, index) => (
            <div
              key={category.id}
              className={`group cursor-pointer transition-all duration-300 rounded-2xl shadow-sm hover:shadow-md hover:scale-[1.02] ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              data-testid={`category-${category.name.toLowerCase().replace(' ', '-')}`}
            >
              {/* Title above image */}
              <h3 className="text-xl font-semibold text-[#2B2B2B] mt-4 mb-2 text-center px-2">
                {category.name}
              </h3>
              {/* Image */}
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4] bg-[#ECE7E1] mb-2">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
